import React from 'react';

function Story({ withImage, path_story, onHover }) {
  const contentSentences = path_story.content.split(/(?<=\.)\s/);

  const handleHover = (index) => {
    const hoverTime = new Date().getTime(); // 現在のUNIX時間を取得
    console.log(`Hovered over sentence at index ${index} at UNIX timestamp ${hoverTime}`);
    onHover({ index, hoverTime }); // インデックスとUNIX時間を渡す
  };

  return (
    <div className={`bg-white border border-gray-300 ${withImage ? 'w-auto' : 'w-3/4'}`}>
      <h1 className="font-semibold text-xl text-center hover:bg-gray-100 m-2">
        {path_story.title}
      </h1>
      <div className="max-h-[calc(100vh-120px)] overflow-y-auto">
        <div className="p-6">
          {contentSentences.map((sentence, index) => (
            <p
              key={index}
              className="transition-colors hover:bg-gray-100"
              onMouseEnter={() => handleHover(index)} // マウスオーバー時にハンドラーを呼び出す
            >
              {sentence.trim()} 
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Story;
